import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Known } from '../../models/known.model';

@Component({
    selector: 'app-known-selector',
    templateUrl: './known-selector.component.html',
    styleUrls: ['./known-selector.component.scss']
})
export class KnownSelectorComponent implements OnInit {

    @Input() knowns          : Known[];
    @Input() selected?       : Known;
    @Input() defaultSelected?: boolean = false;
    @Input() placeholder?    : string = 'Seleccione una opción...';
    @Input() showClear?      : boolean = false;
    @Input() showFilter?     : boolean = false;

    @Output() selectedChange = new EventEmitter<Known>();

    constructor() { }

    ngOnInit(): void {

        this.selected = this.defaultSelected ? this.knowns[0] : this.selected;
        this.onSelectionChange();

    }

    public onSelectionChange() {

        this.selectedChange.emit(this.selected);

    }

}
